import {XeroHttp} from "@/http/XeroHttp";

export default {
    async setServices({commit}) {
        try {
            const service = await XeroHttp.getServices().then(services => services.data);
            commit('setServices', service.body.items);
        } catch (e) {
            return e;
        }

    },
    async setCategories({commit}) {
        try {
            const categories = await XeroHttp.getCategories().then(categories => categories.data);
            commit('setTechnicians', categories.body.trackingCategories[0].options);
            commit('setPeriods', categories.body.trackingCategories[1].options);
        } catch (e) {
            return e;
        }

    },
    async setAccounts({commit}) {
        try {
            const accounts = await XeroHttp.getAccounts().then(accounts => accounts.data);
            commit('setAccounts', accounts.body.accounts);
        } catch (e) {
            return e;
        }

    }
}
